import ingredientCalculator from './_ingredient-calculator';
import toggleHeaderSearch from './_toggle-header-search';
import toggleMobileMenu from './_toggle-mobile-menu';

function init() {
  ingredientCalculator();
  toggleHeaderSearch();
  toggleMobileMenu();
}

init();